import { Typography } from "@material-ui/core";
import axios from "axios";
import moment from "moment/moment";
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { constants } from "../Helpers/constantsFile";
import { TextField } from "@mui/material"

const UsersReport = () => {

  const [userTrans, setUserTrans] = useState()
  const [startDate, setStartDate] = useState(() => {
    const oneWeekAgo = moment().subtract(7, 'days').toISOString().split('T')[0];
    return oneWeekAgo;
  });
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const today = new Date()
  const token = useSelector(state => state.token.token)

  const readUserTrans = () => {
    axios.get(`${constants.baseUrl}/users/get-users-with-customers-and-recent-transactions?startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          'authorization': token
        },
      }).then((res) => {
        console.log(res?.data?.data)
        setUserTrans(res?.data?.data)
      }).catch((err) => {
        alert(err.response.data.message);
      });
  }

  useEffect(() => {
    readUserTrans()
  }, [startDate, endDate])
  
  let total = 0
  userTrans?.map(tran => {
    if (tran.user?.registrationFee)
    total += tran.user?.registrationFee
  })



  return (

    <div style={{ width: "93%", margin: "20px auto" }}>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between",
    width: "100%" }}>
        <Typography style={{ fontSize: "22px", fontWeight: "bold", }}>
          Users Report </Typography>
        <div style={{ marginBottom: '20px',  }}>
          <TextField
            size="small"
            variant="outlined"
            type="date"
            label="Start Date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: '20px' }}
          />
          <TextField
            size="small"
            variant="outlined"
            type="date"
            label="End Date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: '20px' }}
          />
        </div>

      </div>

      <div style={{
        width: "100%", display: "flex", flexDirection: "column",
        gap: "12px"
      }}>

        {userTrans?.map((tran, index) => {
          return <div style={{
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            background: tran?.customerCount < 15 ? "gold" : "white",
            padding: "15px",
            alignItems: "center",
            borderRadius: "10px",
          }}>

            <Typography style={{ fontSize: "16px", flex: 0.2, color: "grey" }}> {index + 1}.</Typography>
            <Typography style={{ fontSize: "16px", flex: 2 }}> {tran.user?.name}</Typography>
            <Typography style={{ fontSize: "16px", flex: 1 }}> {tran.user?.phone}</Typography>
            <Typography style={{ fontSize: "16px", flex: 0.5 }}> RE: ${tran.user?.registrationFee}</Typography>
            <Typography style={{ fontSize: "16px", flex: 1 }}> {moment(tran.user?.created_at).format("YYYY-MM-DD")}</Typography>
            <Typography style={{ fontSize: "16px", flex: 0.7 }}> {tran.user?.notify}</Typography>
            <Typography style={{ fontSize: "16px", flex: 0.7 }}> {tran.user?.usageType}</Typography>
            <Typography style={{ fontSize: "16px", flex: 0.5, }}> {tran?.customerCount}</Typography>
            <Typography style={{ fontSize: "16px", flex: 0.5 }}> {tran?.recentTransactions}</Typography>

          </div>
        })}
         <div style = {{display: "flex", flexDirection: "row", gap: "10px",
                  width: "100%", backdround: 'red'}}>
                <Typography style = {{fontSize: "20px", flex: 0.2, color: "grey", textAlign: "right"}}> total:</Typography>
                <Typography style = {{fontSize: "20px", flex: 0.2, fontWeight: "bold"}}> ${total}</Typography>
                </div>

      </div>

    </div>
  )
}

export default UsersReport